import React from 'react';
import styled from 'styled-components';

const Testimonial = () => {

    return(
        <>
        <div className='testemonial'>
            <p>
                "Cordii is fast, efficient and has an excellent eye for image and design. We've always found her easy to work with and couldn't recommend her enough. 
                For everything from show photography to print design she delivers in a very rapid turnaround and works really closely with us to get the perfect results." 
            </p>
            <h3>Laila Noble</h3>
            <p>Artistic Director & Co-Founder of ClartyBurd Theatre</p>
        </div>
        <div className='testemonial'>
            <p>
                "Working with Cordelia was a pleasure from start to finish. 
                She was able to understand exactly what we needed, gave us great advice and ultimately she created the content we were looking for in a short period of time. 
                She works in a professional and efficient manner and we would definitely reach out to her again if needs be! " 
            </p>
            <h3>Janessa Tönnies</h3>
            <p>CCVD Events (FAfW)</p>
        </div>
        </>
    )
};

export default Testimonial;